// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__IwTW7","inputWrap":"Table_inputWrap__3_-eu","col":"Table_col__1YvZy","bmiTooltip":"Table_bmiTooltip__X0U4V"};